import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceInclude from "../../component/ServiceInclude";
import { Helmet } from "react-helmet";


const ServiceCloud = () => {

    const [isVisible, setIsVisible] = useState(false);
    const [explore, setExplore] = useState(false);
    const [solution1, setSolution1] = useState(false);
    const [solution2, setSolution2] = useState(false);
    const [solution3, setSolution3] = useState(false);


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const toggleVisibility = () => {
        setIsVisible(!isVisible);
    };

    const toggleMore = () => {
        setExplore(!explore);
    };

    const toggleSolution1 = () => {
        setSolution1(!solution1);
    };

    const toggleSolution2 = () => {
        setSolution2(!solution2);
    };

    const toggleSolution3 = () => {
        setSolution3(!solution3);
    };

    return (
        <>

            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Top Salesforce Service Cloud Consultant</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content=""
                />
                <meta
                    name="keywords"
                    content=""
                />
            </Helmet>

            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Service Cloud</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/salesforce/service-cloud/service-cloud.webp')} alt="" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">

                        <div className="salesforce-service">
                            <p className="prose-lg wow fadeUp">
                                Salesforce Service Cloud is a customer service software designed to streamline and enhance customer support. It achieves this in several key ways:
                            </p>
                        </div>

                        <div className="sasesforce-benifit">
                            <div className='explore-service text-left'>
                                <h2>Salesforce Implementation Benefits</h2>
                            </div>
                            <div className="row mt-5">
                                <div className="col-md-4">
                                    <div className="benifit-number">
                                        <h3>45% </h3>
                                        <p className="wow fadeUp prose-lg">increase in sales productivity</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="benifit-number">
                                        <h3>47% </h3>
                                        <p className="wow fadeUp prose-lg">increase in sales revenue</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="benifit-number">
                                        <h3>31% </h3>
                                        <p className="wow fadeUp prose-lg">increase in the opportunity win rate</p>
                                    </div>
                                </div>
                                <p className="wow fadeUp prose-lg">Source: Salesforce Customer Success Metrics Survey</p>
                            </div>
                        </div>

                        <div className="contact-shadow top_padding">
                            <div className="row mb-4">
                                <div className="valuation-box">
                                    <div className="col-md-9">
                                        <h3>Taste the Benefits of Your Future Solution!</h3>
                                        <p className="prose-lg wow fadeUp">Request a personalized Salesforce Service Cloud demo and discover how it can benefit YOUR business.</p>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="button_exp mt-5">
                                            <Link to="/contact"><button>Contact us</button> </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="cloud-demo mb-3">
                            <div className='explore-heading text-left'>
                                <h2>Salesforce Service Cloud Demo</h2>
                                <div className="cloud-video">
                                    <iframe
                                        width="100%"
                                        height="450" src="https://www.youtube.com/embed/tRhzdHSMgLI?si=DS854BqRt0lrghY-"
                                        title="YouTube video player"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerpolicy="strict-origin-when-cross-origin"
                                        allowfullscreen>
                                    </iframe>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Key Features of Salesforce Service Cloud</h2>
                                <p className="wow fadeUp prose-lg text-left"> Browse through the list of key Service Cloud features to gain a deeper understanding of its powerful functionality.</p>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/service-cloud/cloud-1.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Omni-Channel</h3>
                                            <p className="wow fadeUp prose-lg">This feature allows your customer support to excel across multiple communication channels of your choice, including web, email, phone, live agent chats (web or mobile), social media platforms (Facebook, Instagram, Twitter, Google+, and Sina Weibo), community sites, and even video chats. In addition to consolidating cases from all these channels into your Service Cloud, Omni-Channel intelligently routes them to the right agents based on pre-defined, complex conditions.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/service-cloud/cloud-2.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Case Management</h3>
                                            <p className="wow fadeUp prose-lg">Service Cloud Case Management handles the entire case lifecycle: from creation and prioritization to assignment, escalation, reassignment, and closure. You can set specific parameters to influence each stage, and Service Cloud will automate the process. For instance, if you want the case priority and type to determine the assigned agent, Service Cloud will analyze this information and trigger the appropriate assignment mechanism automatically.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/service-cloud/cloud-3.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Service Console</h3>
                                            <p className="wow fadeUp prose-lg">This is the ultimate personal work space for every agent. Service Console provides a very convenient view of each case. Apart from showing case state and history, it depicts customer and/or account information and enables agents to look for needed knowledge articles right in the case record.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/service-cloud/cloud-4.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Knowledge Base</h3>
                                            <p className="wow fadeUp prose-lg">To help your service agents find answers quickly and resolve cases more efficiently, Service Cloud allows you to create a comprehensive knowledge base. Additionally, the ability to evaluate the usefulness of each knowledge article enhances the base, enabling you to improve less effective articles for better support.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/service-cloud/cloud-5.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Process and Routine Automation</h3>
                                            <p className="wow fadeUp prose-lg">Service Cloud provides process automation through workflows, approvals, macros, email templates, and more, streamlining tasks and improving efficiency.</p>

                                            <div className="onClick-more-icons" onClick={toggleVisibility}>
                                                Explore More<i class="fa fa-chevron-down" aria-hidden="true"></i>
                                            </div>
                                            {isVisible && (
                                                <div>
                                                    <p className="prose-lg">For instance, if a customer is highly dissatisfied with support and agent Greg determines that a customer incentive is necessary, a workflow in Salesforce automatically sends an incentive approval request to Greg's manager, Jane. Once she approves it, Greg can offer the incentive to the customer by selecting and sending the appropriate email template. On another day, Greg notices 7 similar cases in the system. He runs a bulk macro to respond to all of them at once, resolving the cases efficiently. Then, he runs another macro to automatically close them. This kind of automation significantly saves time for both agents and managers.</p>

                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/service-cloud/cloud-6.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Service Analytics</h3>
                                            <p className="wow fadeUp prose-lg">Service Analytics, powered by Salesforce Einstein, is accessible to both service agents and managers, offering valuable insights into department and agent performance. It provides reports of varying complexity, helping you track and analyze key metrics effectively.</p>

                                            <div className="onClick-more-icons" onClick={toggleMore}>
                                                Explore More<i class="fa fa-chevron-down" aria-hidden="true"></i>
                                            </div>
                                            {explore && (
                                                <div>
                                                    <p className="prose-lg">It could be a report on the first contact resolution rate or the number of case reassignments per case type, showing the average customer satisfaction (CSAT) rate for each case type, as well as identifying agents who frequently reassign cases beyond a set threshold each week. In addition to detailed reporting, Service Analytics also provides recommendations on actions an agent can take to improve CSAT scores.</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/service-cloud/cloud-7.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Field Service</h3>
                                            <p className="wow fadeUp prose-lg">At times, resolving a case requires collaboration between service agents and field workers. Field Service enables this seamless coordination. Service Cloud users can schedule appointments with field workers, manage their schedules, track the usage of parts or materials, and more.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/service-cloud/cloud-8.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Self-Service Communities</h3>
                                            <p className="wow fadeUp prose-lg"> Service Cloud allows you to create self-service communities where customers can access your knowledge base and find solutions independently. To enhance the community experience, you can also add a chat feature, enabling customers to easily reach out to agents for assistance if they can't find the answers themselves.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/service-cloud/cloud-9.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Einstein Bots</h3>
                                            <p className="wow fadeUp prose-lg"> In some cases, your chats can be powered by Salesforce Einstein. This will free up some of your agents’ time and provide customers with answers to trivial questions about, say, an order status, flight details, etc. And only if your chat bot can’t help, it will transfer customers to the agents competent in the area of the customer’s problem.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/service-cloud/cloud-10.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">App Builder</h3>
                                            <p className="wow fadeUp prose-lg"> If you find that something is still missing from the Service Cloud functionality, you can have custom Salesforce customer service apps developed to meet your specific needs using this feature.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="selesforce-services mt-5 mb-4">
                            <div className='explore-heading text-left'>
                                <h2>Key Features of Salesforce Sales Cloud</h2>
                                <p className="wow fadeUp prose-lg text-left">By integrating your Service Cloud with Sales or Marketing Clouds, you unlock even more possibilities:</p>
                            </div>
                            <div className="why-listing mt-4">
                                <ul>
                                    <li className="wow fadeUp prose-lg"> With Sales Cloud data, agents gain a more comprehensive view of a customer's history with the company. Conversely, Service Cloud data allows your sales managers to track how customer service impacts customer retention.</li>
                                    <li className="wow fadeUp prose-lg"> By leveraging Service Cloud data, you can use Marketing Cloud to analyze how customer service impacts your company’s brand image. Additionally, by understanding the issues customers face with your products or services, you can refine your marketing campaigns and develop new product or service offerings.</li>
                                </ul>
                                <p className="wow fadeUp prose-lg">Alternatively, you can integrate Service Cloud with other CRM and marketing tools to further enhance your customers' experience with your company.</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className='explore-heading text-left'>
                                <h2>Optimize Your Customer Service Operations with Salesforce</h2>
                            </div>
                            <div className="col-lg-12 col-md-12">
                                <Swiper
                                    breakpoints={{
                                        640: {
                                            slidesPerView: 1,
                                            spaceBetween: 10,
                                        },
                                        768: {
                                            slidesPerView: 1,
                                            spaceBetween: 30,
                                        },
                                        1024: {
                                            slidesPerView: 1,
                                            spaceBetween: 30,
                                        },
                                    }}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    modules={[Pagination]}
                                    className="testimonialSwiper-blog-service-contribute"
                                >

                                    <SwiperSlide className="opportunities">
                                        <img src={require('../../assets/images/salesforce/service-cloud/services-1.webp')} alt='' />
                                        <h3>A single interface for omnichannel customer support</h3>
                                    </SwiperSlide>
                                    <SwiperSlide className="opportunities">
                                        <img src={require('../../assets/images/salesforce/service-cloud/service-2.webp')} alt='' />
                                        <h3>Remote service sessions eliminating the need for on-site visits</h3>
                                    </SwiperSlide>
                                    <SwiperSlide className="opportunities">
                                        <img src={require('../../assets/images/salesforce/service-cloud/service-3.webp')} alt='' />
                                        <h3>Contextual recommendations of relevant knowledge resources</h3>
                                    </SwiperSlide>

                                </Swiper>
                            </div>
                        </div>

                        <div className="contact-shadow top_padding">
                            <div className="row mb-4">
                                <div className="valuation-box">
                                    <div className="col-md-9">
                                        <h3>Salesforce Service Cloud Demo</h3>
                                        <p className="prose-lg wow fadeUp">Check out our demo to see how Service Cloud handles case resolution in action.</p>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="button_exp mt-5">
                                            <Link to="/contact"><button>Try Out</button> </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="Choose-plan-section bottom_padding">
                            <div className='explore-heading text-left'>
                                <h2>Pricing</h2>
                                <p className="wow fadeUp prose-lg text-left">Like many Salesforce products, Service Cloud offers the following 4 editions:</p>
                            </div>
                            <div className="row top_padding">
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item">
                                        <h3>Essentials</h3>
                                        <p className="prose-lg pricing">Like many Salesforce products, Service Cloud offers the following 4 editions:</p>

                                        <p className="prose-lg text-center mt-5"><span>$25</span>user/month</p><br /><br />
                                        <div className="demo-button">
                                            <button>Request demo</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item">
                                        <h3>Professional</h3>
                                        <p className="prose-lg pricing">Includes Essentials edition features for unlimited users, plus customization, SLAs, entitlements, and advanced field service capabilities.</p>

                                        <p className="prose-lg text-center"><span>$75</span>user/month</p>
                                        <div className="demo-button">
                                            <button>Request demo</button>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 mt-3">
                                    <div className="plan-item">
                                        <h3>Enterprise</h3>
                                        <p className="prose-lg pricing">Includes Professional edition features plus advanced case management, reporting, automation, and integration with external systems via APIs.</p>

                                        <p className="prose-lg text-center mt-5"><span>$150</span>user/month</p>
                                        <div className="demo-button">
                                            <button>Request demo</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item">
                                        <h3>Unlimited</h3>
                                        <p className="prose-lg pricing">The richest functionality with 24/7 support and configuration services included.</p>

                                        <p className="prose-lg text-center mt-5"><span>$300</span>user/month</p><br /><br /><br />
                                        <div className="demo-button">
                                            <button>Request demo</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="contact-shadow top_padding">
                            <div className="row mb-4">
                                <div className="valuation-box">
                                    <div className="col-md-9">
                                        <h3>Need More Details about Service Cloud Editions?</h3>
                                        <p className="prose-lg wow fadeUp">If you're still unsure which Service Cloud edition is best for your business, our Salesforce consultants can offer a comprehensive overview of their features and functionality.</p>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="button_exp mt-5">
                                            <Link to="/contact"><button>Get a personalized offering</button> </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Common Customer Service Challenges Addressed with Service Cloud</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-1 col-md-1'>
                                    </div>
                                    <div className='col-lg-11 col-md-11'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Challenge #1</h3>
                                            <p className="wow fadeUp prose-lg">Limited accessibility to your customer service can lead to customer churn.s</p>

                                            <div className="onClick-more-icons" onClick={toggleSolution1}>
                                                Explore More<i class="fa fa-chevron-down" aria-hidden="true"></i>
                                            </div>
                                            {solution1 && (
                                                <div>
                                                    <p className="prose-lg"><strong>Solution</strong></p>
                                                    <p className="prose-lg">With Salesforce Service Cloud, your agents no longer need to switch between multiple applications and devices or place customers on hold. The platform integrates various communication channels, allowing seamless management of calls, chats, and more. Features like Computer Telephony Integration, Omni-Channel, Web/Email Case Capture, and others enable you to connect your company’s phones, website, self-service community, social media accounts, and more directly to Service Cloud. Additionally, cases can be automatically routed to the most qualified agents based on their type. This ensures your clients can reach support through their preferred channel and get quick, efficient assistance.</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-1 col-md-1'>
                                    </div>
                                    <div className='col-lg-11 col-md-11'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Challenge #2</h3>
                                            <p className="wow fadeUp prose-lg">Extremely long case resolution time or frequent inability to resolve a case results in low customer satisfaction.</p>

                                            <div className="onClick-more-icons" onClick={toggleSolution2}>
                                                Explore More<i class="fa fa-chevron-down" aria-hidden="true"></i>
                                            </div>
                                            {solution2 && (
                                                <div>
                                                    <p className="prose-lg"><strong>Solution</strong></p>
                                                    <p className="prose-lg">Service Cloud Case Management automates case processes such as assignment, prioritization, and escalation, minimizing human error and boosting productivity. For instance, to speed up case resolutions, Service Cloud assigns cases based on agent expertise and allows knowledge searches directly within the Service Console. Productivity-enhancing tools like macros and email/message templates further streamline workflows, enabling agents to focus on resolving customer issues quickly, which improves customer satisfaction. However, there may be situations where agents are unable to resolve a case. In these cases, you can establish a clear incentive process to help ease customer frustrations.</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-1 col-md-1'>
                                    </div>
                                    <div className='col-lg-11 col-md-11'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Challenge #3</h3>
                                            <p className="wow fadeUp prose-lg">Challenge: Inability to Effectively Monitor and Manage Customer Service</p>

                                            <div className="onClick-more-icons" onClick={toggleSolution3}>
                                                Explore More<i class="fa fa-chevron-down" aria-hidden="true"></i>
                                            </div>
                                            {solution3 && (
                                                <div>
                                                    <p className="prose-lg"><strong>Solution</strong></p>
                                                    <p className="prose-lg"> Service Cloud provides comprehensive monitoring and management capabilities for customer service teams. As agents carry out their tasks, the platform collects data on their performance, as well as the performance of the entire department. This data enables agents and managers to generate reports on any field within the platform, with the added flexibility of using formulas for more advanced reporting. For even deeper insights, Service Analytics offers detailed analysis, revealing valuable information such as communication channel performance and predicted CSAT scores, helping you optimize customer service operations.</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Codezix Service Cloud Services</h2>
                                <p className="wow fadeUp prose-lg text-left">Service Cloud provides a robust suite of capabilities for customer service, but it’s not a one-size-fits-all solution. Think of it as a Lego kit—packed with potential, but requiring careful arrangement, customization, and sometimes significant adjustments to fully unlock its power for your business. Whether you’re just starting to explore Salesforce or already deep into the decision-making process, ScienceSoft is here to assist. Our core Service Cloud services include:</p>
                            </div>

                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/consulting">
                                            <h3 class="mt-0">Salesforce Consulting</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/implementation">
                                            <h3 class="mt-0">Salesforce Implementation</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud#">
                                            <h3 class="mt-0">Salesforce Migration</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/managed">
                                            <h3 class="mt-0">Salesforce Managed Services</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="contact-shadow top_padding">
                            <div className="row mb-4">
                                <div className="valuation-box">
                                    <div className="col-md-9">
                                        <h3>Improve Your Customer Service with Codezix</h3>
                                        <p className="prose-lg wow fadeUp">If your top priority is ensuring customer satisfaction, ScienceSoft's Salesforce services are exactly what you need.</p>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="button_exp mt-5">
                                            <Link to="/contact"><button>Get a free consultation</button> </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default ServiceCloud;